import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { groupBy } from 'lodash';
import { BUY_PAGE } from '../../../constants/pages';
import useCheckPermissions from '../../../util/hooks/useCheckPermissions';
import { VIEW_TYPE_OPTIONS } from '../../../constants/holdingsConstants';
import { parseEnumType } from '../../../util/helpers/enumMappers';
import {
  productLocationTypes,
  productMetalTypes,
} from '../../../util/enum/api/productTypes';
import HoldingsContainer from './HoldingsContainer';
import SummaryContainer from '../Summary/SummaryContainer';
import { EmptyTable, EmptyTableButton } from '../../EmptyTable/EmptyTable';
import { separateByUppercase } from '../../../util/helpers/stringHelpers';
import { selectSettings } from '../../../store/selectors/settingsSelectors';

const HoldingView = ({ holdings, showProducts, viewType, totalValuation }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { allowAccountChangesPermission } = useCheckPermissions();
  const settings = useSelector(selectSettings);
  const segregatedCaption = settings?.SegregatedCaption;

  const sortProductsByViewType = () => {
    const { value } = viewType;

    switch (value) {
      case VIEW_TYPE_OPTIONS[0].value:
        return groupBy(
          holdings,
          (holdingItem) =>
            `${separateByUppercase(
              parseEnumType(productLocationTypes, holdingItem.LocationType),
            )} ${holdingItem.IsSegregated ? `(${segregatedCaption})` : ''}`,
        );

      case VIEW_TYPE_OPTIONS[1].value:
        return groupBy(holdings, (holdingItem) =>
          parseEnumType(productMetalTypes, holdingItem.MetalType),
        );

      case VIEW_TYPE_OPTIONS[2].value:
        return groupBy(
          holdings,
          (holdingItem) => holdingItem.ProductDetailCaption,
        );

      default:
        break;
    }
  };

  const sortedHoldings = sortProductsByViewType();

  const isSortByProduct = () => {
    if (viewType.value === VIEW_TYPE_OPTIONS[2].value) {
      return true;
    }

    return false;
  };

  const isSortByType = () => {
    if (viewType.value === VIEW_TYPE_OPTIONS[1].value) {
      return true;
    }

    return false;
  };

  const isSortByVault = () => {
    if (viewType.value === VIEW_TYPE_OPTIONS[0].value) {
      return true;
    }

    return false;
  };

  if (showProducts) {
    return (
      <>
        {showProducts && (
          <HoldingsContainer
            sortedHoldings={sortedHoldings}
            totalValuation={totalValuation}
            isSortByProduct={isSortByProduct()}
            isSortByVault={isSortByVault()}
            isSortByType={isSortByType()}
          />
        )}

        {showProducts && (
          <SummaryContainer
            holdings={sortedHoldings}
            totalValuation={totalValuation}
            isSortByProduct={isSortByProduct()}
            isSortByVault={isSortByVault()}
            isSortByType={isSortByType()}
          />
        )}
      </>
    );
  }

  return (
    <EmptyTable>
      <p>{t('portfolio.holdings.tableEmptyOne')}</p>
      <p>{t('portfolio.holdings.tableEmptyTwo')}</p>

      <EmptyTableButton
        disabled={!allowAccountChangesPermission}
        variant="primary"
        onClick={() => history.push(BUY_PAGE)}
      >
        {t('portfolio.holdings.buyBtnLabel')}
      </EmptyTableButton>
    </EmptyTable>
  );
};

HoldingView.propTypes = {
  showProducts: PropTypes.bool,
  holdings: PropTypes.arrayOf(PropTypes.shape({})),
  viewType: PropTypes.shape({
    value: PropTypes.string,
  }),
  totalValuation: PropTypes.number,
};

export default HoldingView;
